<template>
  <div v-if="showNotice" class="player-notice-box">
    <button type="button" :class="getButtonClass" @click.prevent="toggleDetail">
      <span class="inner">
        <span class="badge-cell">
          <em class="player-notice-icon">공지사항</em>
        </span>
        <span class="player-notice-title-text">{{ notice.title || '' }}</span>
      </span>
    </button>
    <div v-if="showDetail" class="player-notice-content">
      <span class="player-notice-content-date">{{
        notice.noticedate || ''
      }}</span>
      <p class="w-break">{{ notice.description }}</p>
    </div>
  </div>
</template>
<script>
  import { getProgramNotice } from '@/common/utils/request'
  import _ from 'lodash'

  export default {
    name: 'PlayerNotice',
    props: {
      contentId: {
        type: String,
      },
    },
    data() {
      return {
        showNotice: false,
        showDetail: false,
        notice: null,
      }
    },
    computed: {
      getButtonClass() {
        return this.showDetail
          ? 'player-notice-button player-notice-close'
          : 'player-notice-button player-notice-open'
      },
      description() {
        return _.get(this.notice, 'description', '').replace(/\n/gi, '<br>')
      },
    },
    watch: {
      contentId() {
        this.init()
        this.setData()
      },
    },
    created() {
      this.setData()
    },
    methods: {
      setData() {
        getProgramNotice(this.contentId).then(({ data }) => {
          const list = _.get(data, 'list', [])
          if (list.length > 0) {
            this.notice = list[0]
            this.showNotice =
              _.get(list, ['0', 'status'], 'N').toUpperCase() === 'Y'
          }
        })
      },
      toggleDetail() {
        this.showDetail = !this.showDetail
      },
      init() {
        this.notice = null
        this.showNotice = false
      },
    },
  }
</script>
<style lang="scss" scoped>
  .w-break {
    white-space: pre-line;
  }
</style>
